import { hostsConfig } from '@openeducation/oe-it-services';
import type { Environment } from '@openeducation/oe-it-services';
import axios from 'axios';

export default abstract class KeepAliveDao {
  static async getServerTime(env: Environment) {
    const url = hostsConfig[env].progressServiceUrl;

    const { data } = await axios.get<number>(`${url}/v1/keepalive/time`);

    return data;
  }

  static async postAlive(
    env: Environment,
    teacherId: number,
    loginUuid: string
  ) {
    const url = hostsConfig[env].progressServiceUrl;

    const { data } = await axios.post<number>(
      `${url}/v1/keepalive/${loginUuid}`,
      teacherId,
      { headers: { 'Content-Type': 'application/json' } }
    );

    return data;
  }
}
